import { isUnderDistance } from "../../../utils/coordinatesGps";
import { slugify } from "../../../utils/slugifyString";

const filterBehaviour = (
  filteredData,
  filterState,
  filterKeys,
  setFilteredEntities,
  searchState,
  mapRef,
  selectedGeoAdress,
  dataFilters
) => {
  //------------- Check if state is not empty so the filter doesn't trigger
  const isStateFilled = () => {
    for (const key in filterState) {
      if (filterState[key].length > 0) {
        return true;
      }
    }
    return false;
  };

  const createSlug = (string) => {
    return string
      .toLowerCase()
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .trim()
      .replace(/[^a-z0-9\s-]/g, '')
      .replace(/\s+/g, '_')
      .replace(/-+/g, '_');
  };


  if (isStateFilled()) {
    let tempFilteredData = [];

    // custom filter gdh_logement
    const filterNameRangePrice = "budget_max"
    const filterNameRangeDistance = "distance_max"
    const filterNameCommune = "town"

    // reset filter distance if commune disable



    //----Construction du tableau de tableau d'entité(s) qui correspond(ent) aux filtres sélectionnés
    // console.log("🚀 ~ filterState:", filterState)
    for (const key in filterState) {
      if (filterState[key].length > 0) {
        tempFilteredData = [
          ...tempFilteredData,
          filteredData.filter((entity) => {

            if (!entity[key] && filterNameRangeDistance !== key) {
              return true
            }
            if (filterState[filterNameCommune]?.length !== 1 && filterNameRangeDistance === key) {
              // filterState[filterNameRangeDistance].pop()
              return true
            }
            // filter by distance
            if (filterNameRangeDistance === key && filterState[key][0] !== undefined) {
              const coordinatesLocalisation = dataFilters.town.values.find(etl => etl.slug === filterState[filterNameCommune][0])
              return isUnderDistance(entity, coordinatesLocalisation, filterState[key][0])
            }
            return entity[key].some((item) => {
              if (filterNameRangePrice === key) {
                if (typeof item === "string") item = item.replace(/\s/g, "")
                return parseFloat(filterState[key]) >= parseFloat(item)
              } else {
                // console.log(filterState[key], item)
                return filterState[key].includes(createSlug(item))
              }
            })
          }
          ),
        ];
      }
    }

    //--- Filter entity depending on the selected filters, flat the data and only keep the entities that are in all tempFiltederData subArray
    if (tempFilteredData.length > 1) {

      //filters data based on max distance if this exists, otherwise based on communes
      const filteredStateCopie = { ...filterState };

      Object.keys(filteredStateCopie).forEach(key => {
        if (!filteredStateCopie[key] || (Array.isArray(filteredStateCopie[key]) && filteredStateCopie[key].length === 0)) {
          delete filteredStateCopie[key];
        }
      });
      if (filterState[filterNameRangeDistance]?.length !== 0 && filterState[filterNameCommune]?.length === 1) {
        const keys = Object.keys(filteredStateCopie);
        const indexDistanceMax = keys.indexOf(filterNameCommune);
        if (indexDistanceMax >= 0 && indexDistanceMax < tempFilteredData.length) {
          tempFilteredData.splice(indexDistanceMax, 1);
        } else {
          tempFilteredData.pop();
        }
      }

      // flatten and filter data to obtain a common result
      let flatData = tempFilteredData.flat();
      let necklaceFilteredData = [];
      for (const data of flatData) {
        let tempArray = flatData.filter((elt) => data.id === elt.id);
        if (
          tempArray.length === tempFilteredData.length &&
          !necklaceFilteredData.find((element) => element.id === data.id)
        ) {
          necklaceFilteredData.push(data);
        }
      }
      if (searchState) {
        let tempArray = [];
        for (const data of necklaceFilteredData) {
          if (slugify(data.name).includes(slugify(searchState))) {
            tempArray.push(data);
          }
        }
        setFilteredEntities(tempArray);
      } else {
        setFilteredEntities(necklaceFilteredData);
      }

      return null;
    } else {
      let tempArray = [];
      let flatData = tempFilteredData.flat();
      if (searchState) {
        for (const data of flatData) {
          if (slugify(data.name).includes(slugify(searchState))) {
            tempArray.push(data);
          }
        }
        setFilteredEntities(tempArray);
      } else {
        setFilteredEntities(flatData);
      }
      return null;
    }
  } else {
    let tempArray = [];
    if (searchState) {
      for (const data of filteredData) {
        if (slugify(data.name).includes(slugify(searchState))) {
          tempArray.push(data);
        }
      }
      setFilteredEntities(tempArray);
    } else {
      setFilteredEntities(filteredData);
    }
    return null;
  }
};

export default filterBehaviour;
